import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ConvivaApi } from "src/app/conviva-api";
import { DefaultResponse } from "../models/DefaultResponse";
import { Observable, map } from "rxjs";
import { Consolidado } from "../models/relatorio/Consolidado";
import { Atividade } from "../models/relatorio/Atividade";

@Injectable({
  providedIn: 'root'
})

export class RelatorioService {
  private api = ConvivaApi;

  constructor(
    private http: HttpClient,
    private router: Router) { }

  public getRelatorioConsolidado(parametros: Consolidado): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.getRelatorioConsolidado}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getRelatorioPendencias(parametros: Consolidado): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.getRelatorioPendencias}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getCalendarioOcorrencias(parametros: Consolidado): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.getCalendarioOcorrencias}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getRelatorioVisitaPsicologo(parametros: Consolidado): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.getVisitaPsicologo}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getRelatorioChamadosUsuario(parametros: Consolidado): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.getRelatorioChamadosUsuario}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getUsuarioChamadosUnicos(parametros: Consolidado): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.getUsuarioChamadosUnicos}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getPerfisChamadosUnicos(parametros: Consolidado): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.getPerfisChamadosUnicos}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getRelatorioOcorrenciasAtivas(parametros: Consolidado): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.getRelatorioOcorrenciasAtivas}`, parametros)
      .pipe(map((Response: DefaultResponse) => Response));
  }

  public getRelatorioCalculoUsabilidade(parametros: Consolidado): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.getRelatorioCalculoUsabilidade}`, parametros)
      .pipe(map((Response: DefaultResponse) => Response));
  }

  public getRelatorioLogVinculoPlanosPMCE(parametros: Consolidado): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.getRelatorioLogVinculoPlanosPMCE}`, parametros)
      .pipe(map((Response: DefaultResponse) => Response));
  }

  public getRelatorioStatusPMCE(parametros: Consolidado): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.getRelatorioStatusPMCE}`, parametros)
      .pipe(map((Response: DefaultResponse) => Response));
  }

  public getDiagnosticoAprovacaoRevertida(parametros: {
    codigoPolo?: number | null;
    codigoDiretoria?: number | null;
    dataInicio?: string | null;
    dataFim?: string | null;
  }): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.getDiagnosticoAprovacaoRevertida}`, parametros)
      .pipe(map((Response: DefaultResponse) => Response));
  }

  public setCorrigeAprovacaoRevertida(parametros: {
    codigoPolo?: number | null;
    codigoDiretoria?: number | null;
    dataInicio?: string | null;
    dataFim?: string | null;
    codigoUsuario: number;
    nomeUsuario: string;
  }): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.setCorrigeAprovacaoRevertida}`, parametros)
      .pipe(map((Response: DefaultResponse) => Response));
  }

  public getAtividadesRelatorio(parametros: Atividade): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.getAtividadesRelatorio}`, parametros)
      .pipe(map((Response: DefaultResponse) => Response));
  }

  public setAtividadesRelatorio(parametros: Atividade): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.setAtividadesRelatorio}`, parametros)
      .pipe(map((Response: DefaultResponse) => Response));
  }

  public downloadRelatividade(parametros: Atividade): Observable<Blob> {
    return this.http.post<Blob>(`${this.api.Relatorios.downloadRelatividade}`, parametros, { responseType: 'blob' as 'json' })
      .pipe(map((Response: Blob) => Response));
  }

  public getDiagnosticoDataRegistroOrfa(parametros: Consolidado): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.getDiagnosticoDataRegistroOrfa}`, parametros)
      .pipe(map((Response: DefaultResponse) => Response));
  }

  public setCorrigeDataRegistroOrfa(parametros: Consolidado): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.setCorrigeDataRegistroOrfa}`, parametros)
      .pipe(map((Response: DefaultResponse) => Response));
  }

  public getBuscaGeralJornada(parametros: {
    codigoJornada?: number | null;
    codigoDiretoria?: number | null;
    codigoEscola?: number | null;
    cpf?: string | null;
    dataInicio?: string | null;
    dataFim?: string | null;
  }): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.getBuscaGeralJornada}`, parametros)
      .pipe(map((Response: DefaultResponse) => Response));
  }

  public getDiagnosticoDuplicatasVisitaPrevencaoPoc(parametros: any): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.getDiagnosticoDuplicatasVisitaPrevencaoPoc}`, parametros)
      .pipe(map((Response: DefaultResponse) => Response));
  }

  public setInativarDuplicatasVisitaPrevencaoPoc(parametros: any): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Relatorios.setInativarDuplicatasVisitaPrevencaoPoc}`, parametros)
      .pipe(map((Response: DefaultResponse) => Response));
  }
}
